import { render, staticRenderFns } from "./AppDropdownItem.vue?vue&type=template&id=65d65616&scoped=true&lang=pug"
import script from "./AppDropdownItem.vue?vue&type=script&lang=js"
export * from "./AppDropdownItem.vue?vue&type=script&lang=js"
import style0 from "./AppDropdownItem.vue?vue&type=style&index=0&id=65d65616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d65616",
  null
  
)

export default component.exports